import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-autodemo-reg',
  templateUrl: './autodemo-reg.component.html',
  styleUrls: ['./autodemo-reg.component.scss']
})
export class AutodemoRegComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
